import { PropallyApiFactory } from "@/module/CustomApiFactory";

import { InvestmentStyleDiagnosis } from "./generated";

// GET /v1/investment_style_diagnosis の唯一の呼び出し定義。
// 結果画面（useGetInvestmentStyleDiagnosis）とホーム（useHomeInvestmentStyleDiagnosis）の両方が使うため、
// 特定画面の配下ではなく共有の src/api/ に置いている。
// エンドポイント・認証オプション・レスポンス検証の仕様変更はこのファイルだけで完結させる。
export const fetchInvestmentStyleDiagnosis = async (): Promise<InvestmentStyleDiagnosis> => {
  const fp = PropallyApiFactory();
  const response = await fp.v1InvestmentStyleDiagnosisGet({ withCredentials: true });
  // 生成クライアントの型（InvestmentStyleDiagnosis）をそのまま返す。
  // unknown へ広げると schema のフィールド改名をコンパイルで検知できなくなるため広げない。
  // ただし型は契約上の宣言であり、実行時は契約外のボディ（200 で `{}`・`[]` 等）が来うる。
  // 呼び出し側は使用前に必ず isRenderableDiagnosisBody で形を確認すること。
  return response.data;
};

// 200 でも空ボディ等が返りうるため、診断済みとして扱う前にボディの形を確認する。
// ホーム（useHomeInvestmentStyleDiagnosis）と結果画面（useGetInvestmentStyleDiagnosis)が
// 共通で使う唯一の判定で、「配列でないオブジェクトで、自身のキーを1つ以上持つ」ことだけを見る
// （`{}`・`[]`・null 等の形だけのボディは一時的な壊れたレスポンスとして弾く）。
// 個々のフィールドの検証は行わない。特に customer_type は必須にしない。API 側は
// allow_nil（判定計算で nil になりうる）ため、必須にすると nil のレコードを持つユーザーが
// retry しても同じボディが返り続け、自分の結果を二度と見られなくなるうえ、ホームでは
// 診断・相性セクションごと消えて結果画面への導線自体を失う。
// customer_type 欠落時の見出し・画像のフォールバックは各表示コンポーネント側が持っている。
// 型は fetchInvestmentStyleDiagnosis が返す生成型のまま受け取り、型述語による断定はしない
// （unknown からの断定にすると schema 改名がコンパイルを素通りしてしまうため）。
export const isRenderableDiagnosisBody = (data: InvestmentStyleDiagnosis | null | undefined): boolean =>
  !!data && typeof data === "object" && !Array.isArray(data) && Object.keys(data).length > 0;
